import { activityDetailConstants } from "../_constants";
import { activityDetailService } from "../_services";
//import { history } from '../_helpers';

export const activityDetailActions = {
  getDetail
};

function getDetail(
  dependant_user_id,
  activity_id,
  start_timestamp,
  end_timestamp
) {
  return dispatch => {
    dispatch(request());

    activityDetailService
      .getDetail(dependant_user_id, activity_id, start_timestamp, end_timestamp)
      .then(
        detail => {
          dispatch(success(detail));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() {
    return { type: activityDetailConstants.DETAIL_STATUS_REQUEST };
  }
  function success(detail) {
    return { type: activityDetailConstants.DETAIL_STATUS_SUCCESS, detail };
  }
  function failure(error) {
    return { type: activityDetailConstants.DETAIL_STATUS_FAILURE, error };
  }
}
